import { InvoiceLineType } from '../enums/invoiceLineType'

// Structurally compatible with both the editor's InvoiceFormLine union (only the row variant
// carries `discount`) and the read-model InvoiceLine (Quote/Invoice API line), so this covers
// both a live form and a fetched document without a cast.
interface DiscountableLine {
  discount?: number
  type: InvoiceLineType
}

// Mirrors the discountMode derivation: a line discount takes precedence over a document-level
// (global) one - the two are mutually exclusive by construction in the editor UI.
export const hasInvoiceLineDiscount = (lines: DiscountableLine[]): boolean =>
  lines.some((line) => line.type === InvoiceLineType.Row && (line.discount ?? 0) > 0)
